import React, { useState } from 'react';
import { useLanguage } from './LanguageContext';
import ContactForm from './ContactForm';
import Snackbar from './Snackbar';
import { sendContactData } from './services/contactService';
import { FaTelegramPlane } from 'react-icons/fa';

// Импортируем изображения подушек и наматрасника
import pillowsImage from './assets/pillows.png';
import namatrassImage from './assets/namatrass.png';
import './CatalogPromo.css';

const CatalogPromo = ({ id }) => {
  const { t, language } = useLanguage();
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [snackbar, setSnackbar] = useState({
    isOpen: false,
    message: '',
    type: 'success'
  });

  // Открытие формы
  const handleOpenForm = () => {
    setIsFormOpen(true);
  };

  // Закрытие формы
  const handleCloseForm = () => {
    setIsFormOpen(false);
  };

  // Отправка данных формы
  const handleFormSubmit = async (formData) => {
    // Показываем "Отправлено" сразу через 1 секунду
    setTimeout(() => {
      setSnackbar({
        isOpen: true,
        message: t('successMessage'),
        type: 'success'
      });
    }, 1000);

    // Отправляем данные в фоне (не ждем)
    try {
      sendContactData({
        ...formData,
        source: 'promo-banner',
        language: language
      })
        .then(result => {
          // Данные отправлены
        })
        .catch(error => {
        });
    } catch (error) {
    }
  };

  // Закрытие snackbar
  const handleCloseSnackbar = () => {
    setSnackbar(prev => ({ ...prev, isOpen: false }));
  };

  return (
    <>
      <section id={id} className="catalog-promo-section">
        
        <div className="promo-banner clickable-banner" onClick={handleOpenForm}>
          <div className="promo-content">
            <span className="promo-badge">АКЦИЯ!</span>
            <p className="promo-text">
              {t('promoText')}
            </p>
            <a 
              href="https://t.me/aison_kz" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="telegram-link"
              onClick={(e) => e.stopPropagation()}
            >
              <FaTelegramPlane />
              <span>Telegram</span>
            </a>
          </div>
          <div className="promo-images-container">
            <img 
              src={pillowsImage} 
              alt="Подушки в подарок" 
              className="promo-image"
            />
            <img 
              src={namatrassImage} 
              alt="Наматрасник в подарок" 
              className="promo-image promo-namatrass"
            />
          </div>
        </div>
      </section>

      {/* Форма контакта */}
      <ContactForm
        isOpen={isFormOpen}
        onClose={handleCloseForm}
        onSubmit={handleFormSubmit}
      />

      {/* Уведомления */}
      <Snackbar
        isOpen={snackbar.isOpen}
        message={snackbar.message}
        type={snackbar.type}
        onClose={handleCloseSnackbar}
        duration={5000}
      />
    </>
  );
};

export default CatalogPromo;